import { useEffect, useState } from "react";
import { Button as BButton, Modal, Spinner } from "react-bootstrap";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Grid, List, ListItemButton, ListItemIcon, ListItemText, Checkbox, Button, Paper } from "@mui/material";

import ApiSupplierAgents from "../../../core/api/api.supplierAgent";

function not(a, b) {
  // پیدا کردن غیر مشترکات دو آرایه از آبجکت ها بر اساس آیدی
  return _.differenceBy(a, b, "id");
}

function intersection(a, b) {
  // پیدا کردن مشترکات دو آرایه از آبجکت ها بر اساس آیدی
  return _.intersectionBy(a, b, "id");
}

export const AddAgentToSupplierModal = ({
  showAddAgentToSupplierModal,
  setShowAddAgentToSupplierModal,
  selectedUserId,
  agents,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [loading, setLoading] = useState(false);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  // console.log("left", left)
  // console.log("right", right)
  // console.log("checked", checked)
  // console.log("leftChecked", leftChecked)
  // console.log("rightChecked", rightChecked)

  const handleToggle = (value) => () => {
    // const currentIndex = checked.indexOf(value);
    const currentIndex = checked.find((item) => item.id === value.id);
    let newChecked = [...checked];
    // console.log("currentIndex", currentIndex)
    if (currentIndex === undefined) {
      newChecked.push(value);
    } else {
      // newChecked.splice(currentIndex, 1);
      newChecked = newChecked.filter((item) => item.id !== value.id);
    }
    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight(right.concat(left));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    // console.log("setLeft", left.concat(rightChecked))
    // console.log("setRight", not(right, rightChecked))
    // return
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
  };

  const handleClose = () => {
    setShowAddAgentToSupplierModal(false);
  };

  const customList = (items) => (
    <Paper sx={{ width: 200, height: 230, overflow: "auto" }}>
      <List dense component="div" role="list">
        {items.map((value) => {
          const labelId = `transfer-list-item-${value.id}-label`;
          return (
            <ListItemButton key={value.id} role="listitem" onClick={handleToggle(value)}>
              <ListItemIcon>
                <Checkbox
                  checked={_.some(checked, { id: value.id })}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    "aria-labelledby": labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={`${value.companyName}`} />
            </ListItemButton>
          );
        })}
      </List>
    </Paper>
  );

  useEffect(() => {
    const fetchAgentSuppliers = async () => {
      setLoading(true);
      try {
        const agentSuppliers = await ApiSupplierAgents.getAllAgentsBySupplierId({ supplierId: selectedUserId });
        const fetchedAgents =
          agentSuppliers.data?.length !== 0 ? agentSuppliers.data.map((item) => ({ id: item.agent.id })) : [];
        if (fetchedAgents.length !== 0) {
          const filteredSuppliers = _.differenceBy(agents, fetchedAgents, "id");
          const commonObjects = _.intersectionBy(agents, fetchedAgents, "id");
          // console.log("filteredSuppliers", filteredSuppliers);
          // console.log("commonObjects", commonObjects);
          setLeft([...commonObjects]);
          setRight([...filteredSuppliers]);
        } else {
          setRight([...agents]);
        }
      } catch (error) {
        console.log("error =>", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAgentSuppliers();
  }, []);

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsSubmitting(true);
      const selectedAgentIds = left.map((item) => item.id);
      console.log("selectedSupplierIds", selectedAgentIds);
      const dataToSendServer = {
        agentIds: selectedAgentIds,
        supplierId: +selectedUserId,
      };
      console.log("dataToSendServer", dataToSendServer);
      const response = await ApiSupplierAgents.createAndUpdateSupplierAgentBySupplierId(dataToSendServer);
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      if (response.succeeded) handleClose();
    } catch (error) {
      console.log("error=", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <Modal centered size="lg" show={showAddAgentToSupplierModal} onHide={handleClose}>
        <form id="form" onSubmit={onSubmit}>
          <Modal.Header closeButton>
            <Modal.Title> افزودن نماینده به تامین کننده </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Grid container spacing={2} sx={{ justifyContent: "center", alignItems: "center", direction: "ltr" }}>
                <Grid item>
                  <p className="ml-6"> نماینده های انتخابی</p>
                  {left?.length === 0 && <div className="mt-5 text-warning"> نماینده ای انتخاب نشده است </div>}
                  {customList(left)}
                </Grid>
                <Grid item>
                  <Grid container direction="column" sx={{ alignItems: "center" }}>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      onClick={handleAllRight}
                      disabled={left.length === 0}
                      aria-label="move all right"
                    >
                      ≫
                    </Button>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      onClick={handleCheckedRight}
                      disabled={leftChecked.length === 0}
                      aria-label="move selected right"
                    >
                      &gt;
                    </Button>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      onClick={handleCheckedLeft}
                      disabled={rightChecked.length === 0}
                      aria-label="move selected left"
                    >
                      &lt;
                    </Button>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      onClick={handleAllLeft}
                      disabled={right.length === 0}
                      aria-label="move all left"
                    >
                      ≪
                    </Button>
                  </Grid>
                </Grid>
                <Grid item>
                  <p className="ml-6">همه نماینده ها</p>
                  {customList(right)}
                </Grid>
              </Grid>
            )}
          </Modal.Body>
          <Modal.Footer>
            <BButton variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </BButton>
            <BButton variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </BButton>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
